import React, { useEffect, useState } from 'react';
import axios from 'axios';

const Contact = () => {
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [msg, setMsg] = useState('');
  const [data, setData] = useState([]);
  const [send, setSend] = useState();
  const formSub = async (e) => {
    setSend(true);
    e.preventDefault();
    const data = {
      name,
      email,
      message: msg,
    };
    const res = await axios.post(
      'https://portfolio-node-7hlx.onrender.com/contact',
      data
    );
    // console.log(res.data)
    if (res.data.submit) {
      setEmail('');
      setMsg('');
      setName('');
      setSend(false);
    }
  };

  const getdata = async () => {
    const res = await axios.get(
      'https://portfolio-node-7hlx.onrender.com/getabout'
    );
    setData(res.data);
  };
  useEffect(() => {
    getdata();
  }, []);
  return (
    <>
      <div className="contact">
        <div className="container">
          <h3 className="text-center p-3">Contact Us</h3>
          <br />
          <br />
          <div className="row text-center">
            {data?.map((val, ind) => {
              return (
                <>
                  <div className="col-md-4 col-sm-6 col-12 mb-3">
                    <div className="card">
                      <img
                        src="image/placeholder.svg"
                        alt=""
                        className="conimg"
                      />
                      <p className="p-3">{val.address}</p>
                    </div>
                  </div>
                  <div className="col-md-4 col-sm-6 col-12 mb-3">
                    <div className="card">
                      <img
                        src="image/phone-call.svg"
                        alt=""
                        className="conimg"
                      />
                      <p className="p-3">{val.phone}</p>
                    </div>
                  </div>
                  <div className="col-md-4 col-sm-6 col-12 mb-3">
                    <div className="card">
                      <img src="image/email.svg" alt="" className="conimg" />
                      <p className="p-3">{val.email}</p>
                    </div>
                  </div>
                </>
              );
            })}
          </div>

          <div className="row pt-3 formm">
            <div className="col-md-6 col-12 mb-3">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3697.341479623986!2d87.88404861495067!3d22.074772185441272!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a02e853c8e3584f%3A0xf52690035006e68a!2sHanschara%20M%20D%20High%20School!5e0!3m2!1sen!2sin!4v1633011739542!5m2!1sen!2sin"
                width="100%"
                height="400"
                style={{ border: '0' }}
                allowfullscreen=""
                loading="lazy"
              ></iframe>
            </div>
            <div className="col-md-6 col-12 mb-3">
              <div className="card p-3">
                <h4 className="text-center">Contact With Me</h4>

                <form onSubmit={formSub}>
                  <div class="form-group">
                    <label>Name:</label>
                    <input
                      type="text"
                      class="form-control"
                      placeholder="Enter Name"
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                      required
                    />
                  </div>
                  <div class="form-group">
                    <label>Email:</label>
                    <input
                      type="email"
                      class="form-control"
                      placeholder="Enter Email"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      required
                    />
                  </div>
                  <div class="form-group">
                    <label for="comment">Message:</label>
                    <textarea
                      class="form-control"
                      rows="3"
                      placeholder="Enter Your Message"
                      value={msg}
                      onChange={(e) => setMsg(e.target.value)}
                      required
                    ></textarea>
                  </div>
                  <div className="text-center">
                    <button
                      type="submit"
                      disabled={send}
                      className="btn btn-dark"
                    >
                      Submit
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Contact;
